import _ from 'lodash/fp';
import { createReducer } from 'reduxsauce';
import { SEARCHGENERAL } from 'actions/Base';

export const INITIAL_STATE = {
  companies: [],
  students: [],
  users: [],
  hitClubs: [],
  productBases: [],
  productOffers: [],
  isLoading: false,
};

export const onStudentSearchRequest = (state) => ({ ...state, isLoading: true });
export const onStudentSearchFailure = (state) => ({ ...state, isLoading: false });
export const onStudentSearchSuccess = (state, { payload }) => {
  return ({ ...state, isLoading: false, companies: payload.companies, students: payload.students});
}

export const onUserSearchRequest = (state) => ({ ...state, isLoading: true });
export const onUserSearchFailure = (state) => ({ ...state, isLoading: false });
export const onUserSearchSuccess = (state, { payload }) => {
  return ({ ...state, isLoading: false, users: payload.content });
}

export const onHitClubSearchRequest = (state) => ({ ...state, isLoading: true });
export const onHitClubSearchFailure = (state) => ({ ...state, isLoading: false });
export const onHitClubSearchSuccess = (state, { payload }) => {
  return ({ ...state, isLoading: false, hitClubs: payload.content });
}

export const onCompanySearchRequest = (state) => ({ ...state, isLoading: true });
export const onCompanySearchFailure = (state) => ({ ...state, isLoading: false });
export const onCompanySearchSuccess = (state, { payload }) => {
  return ({ ...state, isLoading: false, companies: payload });
}

export const onProductBaseSearchRequest = (state) => ({ ...state, isLoading: true });
export const onProductBaseSearchFailure = (state) => ({ ...state, isLoading: false });
export const onProductBaseSearchSuccess = (state, { payload }) => {
  return ({ ...state, isLoading: false, productBases: payload?.content||[] });
}

export const onProductOfferSearchRequest = (state) => ({ ...state, isLoading: true });
export const onProductOfferSearchFailure = (state) => ({ ...state, isLoading: false });
export const onProductOfferSearchSuccess = (state, { payload }) => {
  return ({ ...state, isLoading: false, productOffers: payload.content });
}

export const onSearchHitMemberToChatWithRequest = (state, { params }) => ({ ...state, isLoading: true });
export const onSearchHitMemberToChatWithFailure = (state) => ({ ...state, isLoading: false });
export const onSearchHitMemberToChatWithSuccess = (state, { payload }) => {  
  return ({ ...state, isLoading: false, students: payload?.data?.content.filter(obj => !!obj.student===true).map(hitMember => hitMember.student) });
}

export const ACTION_HANDLERS = {
  [SEARCHGENERAL.STUDENT_SEARCH_REQUEST]: onStudentSearchRequest,
  [SEARCHGENERAL.STUDENT_SEARCH_FAILURE]: onStudentSearchFailure,
  [SEARCHGENERAL.STUDENT_SEARCH_SUCCESS]: onStudentSearchSuccess,

  [SEARCHGENERAL.USER_SEARCH_REQUEST]: onUserSearchRequest,
  [SEARCHGENERAL.USER_SEARCH_FAILURE]: onUserSearchFailure,
  [SEARCHGENERAL.USER_SEARCH_SUCCESS]: onUserSearchSuccess,

  [SEARCHGENERAL.HITCLUB_SEARCH_REQUEST]: onHitClubSearchRequest,
  [SEARCHGENERAL.HITCLUB_SEARCH_FAILURE]: onHitClubSearchFailure,
  [SEARCHGENERAL.HITCLUB_SEARCH_SUCCESS]: onHitClubSearchSuccess,

  [SEARCHGENERAL.COMPANY_SEARCH_REQUEST]: onCompanySearchRequest,
  [SEARCHGENERAL.COMPANY_SEARCH_FAILURE]: onCompanySearchFailure,
  [SEARCHGENERAL.COMPANY_SEARCH_SUCCESS]: onCompanySearchSuccess,

  [SEARCHGENERAL.PRODUCT_BASE_SEARCH_REQUEST]: onProductBaseSearchRequest,
  [SEARCHGENERAL.PRODUCT_BASE_SEARCH_FAILURE]: onProductBaseSearchFailure,
  [SEARCHGENERAL.PRODUCT_BASE_SEARCH_SUCCESS]: onProductBaseSearchSuccess,

  [SEARCHGENERAL.PRODUCT_OFFER_SEARCH_REQUEST]: onProductOfferSearchRequest,
  [SEARCHGENERAL.PRODUCT_OFFER_SEARCH_FAILURE]: onProductOfferSearchFailure,
  [SEARCHGENERAL.PRODUCT_OFFER_SEARCH_SUCCESS]: onProductOfferSearchSuccess,

  [SEARCHGENERAL.HITMEMBER_TO_CHAT_WITH_SEARCH_REQUEST]: onSearchHitMemberToChatWithRequest,
  [SEARCHGENERAL.HITMEMBER_TO_CHAT_WITH_SEARCH_FAILURE]: onSearchHitMemberToChatWithFailure,
  [SEARCHGENERAL.HITMEMBER_TO_CHAT_WITH_SEARCH_SUCCESS]: onSearchHitMemberToChatWithSuccess,
};

export default createReducer(INITIAL_STATE, ACTION_HANDLERS);
